<!-- <div class="d-flex flex-column justify-content-center align-items-center p-0 m-0 dirw-bg-loading"
    [style]="'--backgroundImg:url('+ profilePath +')'">
    <div class="p-4 d-flex flex-row justify-content-center align-items-center text-dark font-monospace">
        <div class="m-0 p-0 me-3">
            <img [src]="underConstructionPath" class="img-fluid" alt="under construction" />
        </div>
        <div class="d-flex" style="height: 150px;">
            <div class="vr"></div>
        </div>
        <div class="d-flex flex-column mt-3 mt-md-0">
            <h3 class="m-0 p-0 ms-3 mb-3 mb-md-0 fw-semibold">Under Constructions</h3>
            <p class="m-0 p-0 ms-3 mb-3 mb-md-0">Sorry for the inconvenience, the page is currently under construction.
            </p>
        </div>
    </div>
</div>
 -->
<app-data-table />